import { Fragment, useEffect, useRef } from "react";
import { Form, Icon } from "semantic-ui-react";
import "react-step-progress-bar/styles.css";
import ProgressStepper from "../ProgressStepper";

const QuestionFormSection = ({ isErrorMessage = {}, QuestionsDetails = [], handleonSubmit = () => { }, handleOnChange = () => { }, showProgressBar = false, steps = 2, progressPercent = 0 }) => {
    const rowRefs = useRef([]);

    useEffect(() => {
        if (isErrorMessage?.notSelectOptions?.length) {
            let findNotSelectOption = rowRefs.current.find((rowRef) => {
                let { id } = rowRef
                let questionId = id?.split('-')[1]
                return isErrorMessage?.notSelectOptions?.includes(parseInt(questionId))
            })
            if (findNotSelectOption) {
                findNotSelectOption.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
        // eslint-disable-next-line
    }, [isErrorMessage?.type])

    const handleInputChange = (e) => {
        handleOnChange(e);
    };

    const handleNextSubmitOption = (e) => {
        e.preventDefault();
        // const formData = new FormData(e.target)
        // let selectedData = Object.fromEntries(formData)
        const formElements = e.target.elements;
        const selectedOptionsData = [];
        for (let element of formElements) {
            const { name, value, id, type, checked } = element;

            const questionId = Number(name);
            const optionId = Number(id)
            const question = QuestionsDetails.find((qd) => qd.questions.some((q) => q.que_id === questionId))?.questions.find((q) => q.que_id === questionId);

            if (question) {
                if (type === 'radio' && checked) {
                    const option = question.options.find((opt) => opt.id === optionId);
                    selectedOptionsData.push({
                        question_id: questionId,
                        question_label: question.question_label,
                        selected_response: option?.label,
                        selected_option_number: Number(value),
                        answer_text: null,
                    });
                } else if (type === 'textarea') {
                    selectedOptionsData.push({
                        question_id: questionId,
                        question_label: question.question_label,
                        selected_response: [null],
                        selected_option_number: optionId,
                        answer_text: value
                    })
                }

            }
        }
        handleonSubmit(selectedOptionsData);
    };

    const renderTableHeader = (isTextAreaQuestion, headerData) => (
        <tr className="bg-[#d2e1fd] dark:bg-[#1c1c1c]">
            {isTextAreaQuestion ? (
                <th colSpan="6" className="px-4 text-[#656575] dark:text-[#F5F5F5] font-semibold text-left">
                    {headerData?.question_label}
                </th>
            ) : (
                <>
                    <th style={{ width: "15%" }} className="pb-4 pt-4 px-2 border-r-[1px] border-[rgba(32,42,49,0.3)] dark:border-[#656575]"></th>
                    {headerData?.options?.map((option, index) => (
                        <th key={`table-header-option-${index}`} style={{ width: "10%" }} className="pb-4 pt-4 px-2 text-[#656575] dark:text-[#F5F5F5] font-semibold text-center">
                            {option?.label}
                        </th>
                    ))}
                </>
            )}
        </tr>
    );


    const renderTableRow = (question, isTextAreaQuestion, index) => (
        <tr key={`table-body-row-${question?.que_id}`} id={`table_row-${question?.que_id}`} ref={el => rowRefs.current[index] = el} className={`${question.ques_type === "Vertical-select" ? "flex flex-col" : (index % 2) ? 'bg-[#eaf1fe] dark:bg-[#2a2a2a]' : "text-left"} ${isErrorMessage?.notSelectOptions?.includes(question?.que_id) ? 'text-red-800 dark:text-orange-600 font-bold' : ''}`}>
            {isTextAreaQuestion ? (
                <td></td>
            ) : (
                <td className="text-left px-2  border-r-[1px] border-[rgba(32,42,49,0.3)] dark:border-[#656575]">
                    {question.question_label}
                </td>
            )}
            {question?.options?.map((option, index) => (
                <td key={`tbody-td-radio-button-${index}_${question?.que_id}`} className={`${question.ques_type === "Vertical-select" ? "w-full" : ""} text-center p-4`}>
                    <div className={`${question.ques_type === "Vertical-select" ? "flex flex-row-reverse items-center" : "flex items-center justify-center"}`}>
                        {question?.ques_type === "Open" && option?.label === "Text" ? (
                            <textarea
                                className="w-full h-24 p-2 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-[#F5F5F5]"
                                name={`${question?.que_id}`}
                                id={`${option?.id}`}
                                placeholder="Please write answer."
                                type='text'
                            />
                        ) : (
                            <Fragment>
                                {question.ques_type === "Vertical-select" && <p className="flex-1 h-auto text-start pl-3 dark:text-[#F5F5F5]">{option?.label}</p>}
                                <input
                                    className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:bg-gray-700 dark:border-gray-600 m-0"
                                    type="radio"
                                    value={option?.id}
                                    name={`${question?.que_id}`}
                                    id={option?.id}
                                />
                            </Fragment>
                        )}
                    </div>
                </td>
            ))}
        </tr>
    );

    return (
        <div className="flex flex-col gap-3">
            <ProgressStepper showStepper={showProgressBar} percent={progressPercent} steps={steps} />
            <div className="question-list_surve pt-5 text-left dark:bg-[#121212] dark:text-[#F5F5F5]">
                <Form className="form-question" onSubmit={handleNextSubmitOption} onInput={handleInputChange}>
                    <div className="p-6 w-full bg-white  rounded-2xl dark:bg-[#212121] transition duration-300 overflow-x-auto">
                        {Array.isArray(QuestionsDetails) && QuestionsDetails.length > 0 ? (
                            QuestionsDetails.map((surveyData, surveyIndex) => {
                                const headerData = surveyData?.questions?.[0];
                                const isTextAreaQuestion = ["Open", "Vertical-select"].includes(headerData?.ques_type);
                                const isFinalQuestion = surveyData?.final_ques;
                                return (
                                    <Fragment key={`survey-question-${surveyIndex}`}>
                                        {
                                            surveyData?.questions?.length ? <>
                                                <div className="font-rubik font-semibold text-center pb-5 text-lg text-[#1A1919] md:text-lg dark:text-[#F5F5F5]">
                                                    {surveyData?.parent_question}
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="w-full border dark:border-[#656575] ">
                                                        <thead className="border-b-[1px] border-[rgba(32,42,49,0.3)] dark:border-[#656575]">
                                                            {renderTableHeader(isTextAreaQuestion, headerData)}
                                                        </thead>
                                                        <tbody className="border-b dark:border-[#656575]">
                                                            {Array.isArray(surveyData?.questions) && surveyData?.questions.length > 0 && surveyData?.questions.map((question, index) => renderTableRow(question, isTextAreaQuestion, index))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="flex items-end justify-end">
                                                    <p className="font-bold text-red-800 dark:text-orange-600 py-3">
                                                        {isErrorMessage?.type ? isErrorMessage?.message : ""}
                                                    </p>
                                                </div>
                                                <div className="pt-4 text-center">
                                                    {!isFinalQuestion ? (
                                                        <button type="submit" className="yellow-button py-3 px-4">
                                                            <Icon name="arrow right" style={{ margin: "0" }} /> Next
                                                        </button>
                                                    ) : (
                                                        <div style={{ textAlign: "center", marginTop: 30 }}>
                                                            <button className="next-button bg-[#cce0f0] text-[#114e7d] font-bold py-3 px-4 rounded-md" type="submit">
                                                                Submit
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </>
                                                : <div className="flex items-center justify-center">
                                                    <h6>No Question Available!</h6>
                                                </div>
                                        }

                                    </Fragment>
                                );
                            })
                        ) : (
                            <div className="flex items-center justify-center">
                                <h6>No Question Available!</h6>
                            </div>
                        )}
                    </div>
                </Form>
            </div>
        </div>
    );
};

export default QuestionFormSection;
